/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps*/
import React, { useState, useMemo, useCallback } from "react";

// Redux
import { useSelector } from "react-redux";

import ManagerPanelIcons from "../../../../../../../../components/Common/ManagerPanelIcons.js";
//Imports of button icons

import {
  Row,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Col,
} from "reactstrap";

import "./ConversationTableHeader.scss";
import "../../../../../../common.scss";

//i18n
import { withTranslation } from "react-i18next";

import ConversationFilterCard from "./ConversationFilterCard";

import DateTime from "luxon/src/datetime.js";

const index = ({
  t,
  onExpand,
  filterCustom,
  setFilterCustom,
  handleFilter,
  payloadDataForm,
  loadingData,
  loadingConversationForm,
  onClearDatePicker,
  handleDatePicker,
  handleRefresh,
  toggleFilter,
  isOpenFilter,
  payloadData,
  conversationClose,
  conversationsChecked: {
    conversationsCheckedArray,
    setConversationsCheckedArray,
  },
}) => {
  const { mainTheme } = useSelector((state) => state.Layout);
  const { conversationTime, loadingConversation } = useSelector((state) => state.Manager) || {};

  const [isExpanded, setIsExpanded] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const toggleDropdown = () => {
    setDropdown((prev) => !prev);
  };

  const toggleThirdContainer = (e) => {
    setIsExpanded(!e);
    onExpand(!e);
  };

  function hasDuplicates(array) {
    return new Set(array).size > 1;
  }

  const handleActionConversationsClosure = useCallback(() => {
    const conversationClosure = conversationsCheckedArray.list?.filter(
      (e) => e
    );

    const isUniqueSkills = hasDuplicates(
      conversationClosure.map((e) => e.skill_name)
    );

    const conversationData = {
      conversations: conversationClosure,
      globalTab: isUniqueSkills,
      isMassActions: true,
    };

    conversationClose(conversationData);
  }, [conversationsCheckedArray?.list]);

  const checkStatusConversations = useMemo(() => {
    if (conversationsCheckedArray?.all) {
      return payloadData?.filter((e) => e);
    }

    return conversationsCheckedArray.list?.filter((e) => e);
  }, [conversationsCheckedArray, payloadData]);

  return (
    <Row className="mt-3">
      <Col>
        <div id="conversation-buttons-area" className="d-flex">
          <span className={`section-title ${mainTheme} mt-2 mr-4`}>
            {t("Chats")}
          </span>

          <section className="d-flex table-selectors-area gap-2">
            {conversationTime && (
              <>
                <span className="mr-2">{`${t("Last Updated")}:`}</span>
                <span>
                  {DateTime.fromJSDate(new Date(conversationTime)).toFormat(
                    "HH:mm:ss dd/MM/yyyy "
                  )}
                </span>
              </>
            )}
          </section>
          <section className="d-flex justify-content-end m-2">
            <ButtonDropdown
              className={`conversation-header-button-wrapper ${
                mainTheme === "dark" ? "dark" : "light"
              } mx-2 ${
                checkStatusConversations.length === 0 ? "isDisabled" : ""
              }`}
              isOpen={dropdown}
              toggle={toggleDropdown}
              disabled={checkStatusConversations.length === 0}
            >
              <DropdownToggle
                caret
                color="link"
                style={{ color: "inherit" }}
                className={`conversation-header-button-wrapper ${
                  mainTheme === "dark" ? "dark" : "light"
                } mx-2 rounded-circle`}
              >
                <i
                  className={`bx bx-plus bx-xs mr-1 mt-1 align-self-center header-button-icons ${
                    loadingData ? "loading-spinning" : ""
                  }`}
                ></i>
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  className={
                    checkStatusConversations.some(
                      (e) =>
                        e.status === "closed" ||
                        e.channel_name === "real_automation"
                    )
                      ? "isDisabled"
                      : ""
                  }
                  disabled={checkStatusConversations.some(
                    (e) =>
                      e.status === "closed" ||
                      e.channel_name === "real_automation"
                  )}
                  onClick={handleActionConversationsClosure}
                >
                  {t("Close selected chats")}
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
            <button
              className={`conversation-header-button-wrapper ${
                mainTheme === "dark" ? "dark" : "light"
              } mx-2`}
              onClick={() => handleRefresh()}
              disabled={loadingConversation}
            >
              <i
                className={`bx bx-refresh bx-xs mr-0 align-self-center header-button-icons header-button-refresh ${
                  loadingData ? "loading-spinning" : ""
                }`}
              ></i>
            </button>
            <button
              className={`conversation-header-button-wrapper ${
                mainTheme === "dark" ? "dark" : "light"
              } mx-2`}
              onClick={() => {
                toggleFilter(!isOpenFilter);
              }}
            >
              <i
                className={`bx bx-filter-alt bx-xs mr-0 align-self-center header-button-icons ${
                  Object.values(filterCustom).some((e) => e && e !== "")
                    ? ""
                    : ""
                }`}
              ></i>
            </button>

            <button
              className={`conversation-header-button-wrapper ${mainTheme} expand mx-2`}
              onClick={() => {
                toggleThirdContainer(isExpanded);
              }}
            >
              {/* <img
                className="conversation-header-button"
                src={isExpanded ? reduceIcon : expandIcon}
                alt="expand-icon-btn"
              /> */}
              {isExpanded ? (
                <ManagerPanelIcons
                  className="table-header-button"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  cx="20"
                  cy="20"
                  r="20"
                  fill={"none"}
                  fillcolor={mainTheme === "light" ? "#556ee6" : "#202533"}
                  d="M0 0H16V16H0z"
                  transform="translate(12 12)"
                  done="M5 14h6v6M3 21l6.1-6.1M20 10h-6V4M21 3l-6.1 6.1"
                  transformone="translate(5 5) translate(3 3)"
                />
              ) : (
                <ManagerPanelIcons
                  className="table-header-button"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  cx="20"
                  cy="20"
                  r="20"
                  fill={"none"}
                  fillcolor={mainTheme === "light" ? "#556ee6" : "#202533"}
                  d="M0 0H16V16H0z"
                  transform="translate(12 12)"
                  done="M10.01 0L6.16 3.85M3.85 6.16L0 10.01M5.39 0L10.01 0 10.01 4.62"
                  transformone="translate(12 12) translate(3 3)"
                  dtwo="M0 5.39L0 10.01 4.62 10.01"
                  transformtwo="translate(12 12) translate(3 3)"
                />
              )}
            </button>

            {/* <button className="conversation-header-button-wrapper mx-2">
              <img
                className="conversation-header-button"
                src={moreOptionsIcon}
                alt="more-options-icon-btn"
              />
            </button> */}
          </section>
        </div>
        <div>
          {isOpenFilter && (
            <ConversationFilterCard
              setFilterCustom={setFilterCustom}
              optionData={payloadDataForm?.form}
              loadingData={loadingConversationForm}
              toggle={toggleFilter}
              filterCustom={filterCustom}
              onClearDatePicker={onClearDatePicker}
              handleDatePicker={handleDatePicker}
              handleFilter={handleFilter}
            />
          )}
        </div>
        <hr />
      </Col>
    </Row>
  );
};

export default withTranslation()(index);
